/* Biolgical universal funnel-events tracker (2026-07-29).
 * Fires the full PostHog funnel event set + FAILURE events on ANY page (custom {% layout none %}
 * landers included) by intercepting the store's cart AJAX / form. Failures also go to
 * posthog.captureException() so they appear on PostHog → Error tracking as issues.
 * Requires posthog already init'd + posthog.register({offer:...}) (present in our templates).
 * Defensive: every hook is try/caught and NEVER blocks the original request. Safe to drop in <head>.
 */
(function () {
  try {
    if (!window.posthog) return;
    // offer tag: resolved LAZILY at capture time, not at load. This script is `defer`-loaded and
    // posthog.js is async, so reading persistence once at init raced it and stamped offer=null on
    // every event (everly PDP, 2026-07-30 — 7 add_to_cart with offer:None).
    function OFFER() {
      try { var g = posthog.get_property && posthog.get_property('offer'); if (g) return g; } catch (e) {}
      try { var p = posthog.persistence && posthog.persistence.props && posthog.persistence.props.offer; if (p) return p; } catch (e) {}
      return document.documentElement.getAttribute('data-offer') || null;
    }

    function cap(ev, props) { try { posthog.capture(ev, Object.assign({ offer: OFFER(), page: location.pathname }, props || {})); } catch (e) {} }
    function fail(name, props) {
      try { posthog.capture(name, Object.assign({ offer: OFFER(), page: location.pathname }, props || {})); } catch (e) {}
      try { posthog.captureException(new Error(name + (props && props.status ? ' status=' + props.status : '')), Object.assign({ offer: OFFER(), page: location.pathname, funnel_failure: true }, props || {})); } catch (e) {}
    }

    // one add = one event: the fetch hook and the form hook can both see the same add, and a
    // double-click fires twice. Collapse anything inside 1.5s.
    var _lastAtc = 0;
    function capAtc(props) {
      // Opt-out for pages that ALREADY fire their own add_to_cart. The 1.5s guard below only
      // dedupes OUR calls — a page script calling posthog.capture('add_to_cart') directly slips
      // past it, so we double-counted every add on phoilex (2 events 44-53ms apart, 2026-07-30)
      // once this tracker landed on a design whose pfx_interactivity.v4.js already captures ATC.
      // Those pages set window.__phSkipAtc; they keep the FAILURE events, which is why the
      // tracker is there at all.
      if (window.__phSkipAtc) return;
      var t = new Date().getTime();
      if (t - _lastAtc < 1500) return;
      _lastAtc = t;
      cap('add_to_cart', props);
    }
    if (window.__phFunnelEvents) return; window.__phFunnelEvents = true;

    // 0) product_viewed — the PostHog twin of Meta's ViewContent, and the step our funnels were
    // missing entirely. Audited 2026-08-02: 0 events on phoilex against 1,715 PDP pageviews,
    // 3 on biolgical against 579. It was in EVENT-TAXONOMY.md but in no gate, so nothing ever
    // fired it and every pageview->product_viewed->add_to_cart funnel read a phantom 100% drop
    // at step two. Meta HAS had ViewContent this whole time (pfx_track is_pdp:true) — only our
    // side was blind, which is the worst shape: it looks measured until you check.
    // Opt-out: window.__phSkipProductViewed (for a page that already fires its own).
    function isPdp() {
      try {
        if (window.__phIsPdp === true) return true;
        if (window.__phIsPdp === false) return false;
        if (/\/products\//.test(location.pathname)) return true;
        return !!document.querySelector('form[action*="/cart/add"]');
      } catch (e) { return false; }
    }
    function productProps() {
      var p = {};
      try {
        var m = location.pathname.match(/\/products\/([^/?#]+)/);
        if (m) p.product_handle = m[1];
        // variant_id is the canonical id in SYSTEM-LANGUAGE.md — read it from the add-to-cart
        // form rather than guessing, and send it as a string like every other surface does.
        var v = document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (v && v.value) p.variant_id = String(v.value);
        var h1 = document.querySelector('h1');
        if (h1 && h1.textContent) p.product_title = h1.textContent.trim().slice(0, 120);
      } catch (e) {}
      return p;
    }
    function fireProductViewed() {
      try {
        if (window.__phSkipProductViewed || window.__phProductViewed) return;
        if (!isPdp()) return;
        window.__phProductViewed = true;
        cap('product_viewed', productProps());
      } catch (e) {}
    }
    // the add-to-cart form can be rendered late by a theme/app, so try at ready AND after load;
    // the __phProductViewed latch keeps it to exactly one event either way.
    if (document.readyState !== 'loading') fireProductViewed();
    else document.addEventListener('DOMContentLoaded', fireProductViewed);
    window.addEventListener('load', fireProductViewed);

    // 1) intercept fetch — catches AJAX /cart/add(.js) and /cart/change, plus checkout starts
    if (window.fetch) {
      var _f = window.fetch;
      window.fetch = function (input, opts) {
        var url = ''; try { url = (typeof input === 'string') ? input : (input && input.url) || ''; } catch (e) {}
        var pr = _f.apply(this, arguments);
        try {
          if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
            pr.then(function (res) {
              try {
                if (res && res.ok) { capAtc({ source: 'ajax' }); }
                else if (res) {
                  res.clone().text().then(function (t) {
                    var body = (t || '').slice(0, 240);
                    fail('add_to_cart_error', { status: res.status, body: body });
                    if (/selling plan/i.test(body)) fail('selling_plan_attach_failed', { status: res.status, body: body });
                    if (/sold out|unavailable|not enough/i.test(body)) fail('add_to_cart_out_of_stock', { status: res.status, body: body });
                  }).catch(function () { fail('add_to_cart_error', { status: res.status }); });
                }
              } catch (e) {}
            }).catch(function () { fail('add_to_cart_error', { status: 'network' }); });
          }
        } catch (e) {}
        return pr;
      };
    }

    // 2) native (non-AJAX) form submit to /cart/add
    document.addEventListener('submit', function (e) {
      try {
        var f = e.target; var a = f && f.getAttribute && f.getAttribute('action');
        if (a && /\/cart\/add/.test(a)) capAtc({ source: 'form' });
      } catch (err) {}
    }, true);

    // 3) initiate_checkout — checkout button / cart-drawer checkout / nav to /checkout|/cart
    //    PLUS [data-direct-checkout]: an OPT-IN attribute for buy buttons that skip the cart and
    //    go straight to /checkouts/… (everly PDP). Without it those pages recorded add_to_cart but
    //    NEVER initiate_checkout — there is no second click to catch. Opt-in, so pages whose ATC
    //    only opens a cart drawer never fire a false IC.

    // ⛔ RENAMED 2026-08-07 initiate_checkout -> checkout_started. EVENT-TAXONOMY.md bans
    // `initiate_checkout` (TRACKING-ARCHITECTURE.md flags it BAD-EVENT) and the router has
    // emitted `checkout_started` for months, so the checkout stage was split across TWO names
    // (phoilex 7d: checkout_started 133 router + 28 web, initiate_checkout 45 web) and every
    // checkout count was wrong unless you remembered to union them. $lib still separates web
    // from shopify-pixel-router and capi_funnel_sync.py excludes $lib='web', so no CAPI dupe.
    // Historical initiate_checkout rows remain — union both names across this date.
    document.addEventListener('click', function (e) {
      try {
        var t = e.target.closest ? e.target.closest('[name="checkout"],a[href*="/checkout"],a[href*="/cart"],button[href*="/checkout"],[data-testid*="checkout"],.js-checkout,#checkout,.cart__checkout,[data-direct-checkout]') : null;
        if (t) cap('checkout_started', { direct: !!(t.hasAttribute && t.hasAttribute('data-direct-checkout')) });
      } catch (err) {}
    }, true);

    // 4) empty-cart checkout attempt = a broken/edge funnel state worth catching
    document.addEventListener('click', function (e) {
      try {
        var t = e.target.closest ? e.target.closest('[name="checkout"],.cart__checkout,#checkout') : null;
        if (!t) return;
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          if (c && (!c.item_count || c.item_count === 0)) fail('checkout_empty_cart', {});
        }).catch(function () {});
      } catch (err) {}
    }, true);
  } catch (e) { /* never break the page */ }
})();
